<template>
    <div>
        <div
            class="d-flex w-100"
            :class="{
                'vuetiful-input-focus': isFocused && !hasError && !aiCustom,
                'text-muted': disabled,
                'vuetiful-input-error': hasError,
                'border bg-white rounded': !aiCustom,
            }"
        >
            <div class="position-relative d-flex align-items-center w-100">
                <label
                    v-if="label"
                    :for="fieldId"
                    id="text-area-label"
                    class="position-absolute top-0 mt-0 mb-2 left-0 font-weight-normal vuetiful-label d-flex"
                    :class="{
                        'vuetiful-label-small': !showPlaceholderLabel,
                        'font-size-125': aiCustom,
                    }"
                    >{{ label }}</label
                >
                <span
                    v-if="this.fieldValue.length > 0"
                    class="position-absolute top-0 right-0 pt-2 font-size-150 cursor-pointer lh-1 pr-1"
                    @click="this.clearField"
                    >&times;</span
                >
                <textarea
                    v-bind:maxlength="maxCharacters"
                    :rows="isRowDynamic ? setRow : rows"
                    class="w-100 no-border rounded-1"
                    :class="{ 'vuetiful-input pl-1': !aiCustom, 'vuetiful-ai-input': aiCustom }"
                    :id="fieldId"
                    v-model="fieldValue"
                    ref="field"
                    :name="name"
                    @focus="onFocus"
                    @blur="onBlur"
                    :placeholder="placeholder"
                />
                <div v-if="!hideLength" class="text-right pr-1 pb-2 position-absolute bottom-0 right-0" :class="{ 'pr-1': aiCustom }">{{ inputLength }} / {{ maxCharacters }}</div>
            </div>
        </div>

        <Transition name="fade-grow">
            <div v-if="hasError && currentError" class="mt-2 vuetiful-input-error-text">
                {{ currentError }}
            </div>
        </Transition>
    </div>
</template>

<script>
import { testIsNonEmptyString } from '../../../../../lib/test-and-assert/test-base';
import GenerateId from '../mixins/GenerateId';

export default {
    name: 'TextArea',
    props: {
        name: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        rows: {
            type: String,
            default: '5',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        hasError: {
            type: Boolean,
            default: false,
        },
        aiCustom: {
            type: Boolean,
            default: false,
        },
        skipFocus: {
            type: Boolean,
            default: false,
        },
        currentError: {
            type: String,
            default: '',
        },
        maxCharacters: {
            type: Number,
        },
        isRowDynamic: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default: '',
        },
        hideLength: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: ''
        }
    },
    mixins: [GenerateId],
    updated() {
        if (this.isRowDynamic) {
            this.textarea.style.height = 'auto';
            this.textarea.style.height = `${this.textarea?.scrollHeight + 20}px`;
        }
    },
    mounted() {
        this.fieldId = this.generateId();
        this.textarea = this.$refs['field'];

        if (testIsNonEmptyString(this.id)) {
            this.fieldId = this.id;
        }

        if (this.value) {
            this.fieldValue = this.value;

            return;
        }

        let autofilled = this.$refs['field'].value;

        if (testIsNonEmptyString(autofilled) && testIsNonEmptyString(autofilled.trim())) {
            this.fieldValue = autofilled.trim();
        }
    },
    watch: {
        value: function (val) {
            this.fieldValue = val;
        },
        fieldValue: function (val) {
            this.$emit('input', val);
            this.inputLength = this.fieldValue.length;
        },
    },
    computed: {
        hasFieldValue: function () {
            return testIsNonEmptyString(this.fieldValue) && testIsNonEmptyString(this.fieldValue.trim());
        },
        showPlaceholderLabel: function () {
            return !this.isFocused && !this.hasFieldValue;
        },
        testValue: function () {
            return this.value;
        },
        setRow() {
            const lines = this.fieldValue.split('\n').length;
            return Math.min(Math.max(this.minRows, lines), this.maxRows);
        },
    },
    methods: {
        onFocus() {
            if (this.skipFocus) {
                return false; // TODO fix this
            }
            this.isFocused = true;
        },
        onBlur() {
            this.isFocused = false;
        },
        clearField() {
            this.fieldValue = '';
        },
    },
    data() {
        return {
            fieldType: '',
            fieldValue: '',
            fieldId: null,
            isFocused: false,
            inputLength: 0,
            minRows: 4, // Minimum number of rows
            maxRows: 24, // Maximum number of rows
            textarea: null,
        };
    },
};
</script>
